import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'src/redux/root'
import { ReactComponent as EnergyModelerIcon } from 'src/svg/EnergyModeler.svg'
import { ReactComponent as GisManagerIcon } from 'src/svg/GisManager.svg'
import { ReactComponent as SustainabilityChampionIcon } from 'src/svg/SustainabilityChampion.svg'

import Accordion from '@material-ui/core/Accordion'
import AccordionActions from '@material-ui/core/AccordionActions'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import Grid from '@material-ui/core/Grid'
import Icon from '@material-ui/core/Icon'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'
import Typography from '@material-ui/core/Typography'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ExpandMore from '@material-ui/icons/ExpandMore'

import { TaskProps } from './TaskTypes'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: {
      marginLeft: '0.5rem',
    },
  }),
)

const Task: React.FC<TaskProps> = ({
  index,
  title,
  DetailsComponent,
  ActionsComponent,
  role,
  completeSelector,
}) => {
  const classes = useStyles()
  const RoleIcon = useMemo(() => {
    if (role === 'Champion') return SustainabilityChampionIcon
    if (role === 'Energy Modeler') return EnergyModelerIcon
    if (role === 'GIS Manager') return GisManagerIcon
    return EnergyModelerIcon
  }, [role])

  const complete = useSelector(completeSelector ?? (() => false))
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Grid container justifyContent='flex-start' alignItems='center' spacing={2}>
          <Grid item>
            <Typography variant='h5'>
              {index}. {title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant='overline'>{role}</Typography>
            {/* <SvgIcon color='primary' className={classes.icon}>
              <RoleIcon />
            </SvgIcon> */}
          </Grid>
          {complete && (
            <Grid item>
              <Icon color='primary'>
                <CheckCircleIcon />
              </Icon>
            </Grid>
          )}
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <DetailsComponent />
      </AccordionDetails>
      {ActionsComponent && (
        <AccordionActions>
          <ActionsComponent />
        </AccordionActions>
      )}
    </Accordion>
  )
}

export default Task
